import {
  getUserData,
  deleteUserData,
  getUserTemplate,
  editUserData,
  getviewUser,
  createUser,
  editRole,
} from "@/http/system/users.js";

export default {
  namespaced: true,
  state: {
    userData: [],
    viewuserData: [],
    userEditData: [],
  },
  actions: {
    async setUsersList({ commit }) {
      try {
        const res = await getUserData();
        commit("SET_USER_LIST", res.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteUserDataAction(_, data) {
      try {
        return await deleteUserData(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createUserAction(_, data) {
      try {
        return await createUser(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editRoleAction(_, payload) {
      try {
        return await editRole(payload.id, payload.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getUserTemplateData(_, data) {
      try {
        return await getUserTemplate(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setUsersEdit({ commit }, data) {
      try {
        const resp = await editUserData(data);
        commit("SET_USER_EDIT_LIST", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setviewUser({ commit }, id) {
      try {
        const resp = await getviewUser(id);
        commit("SET_VIEW_USER", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    SET_USER_LIST(state, payload) {
      state.userData = payload;
    },
    SET_USER_EDIT_LIST(state, payload) {
      state.viewuserData = payload;
    },
    SET_VIEW_USER(state, payload) {
      state.viewuserData = payload;
    },
  },
  getters: {
    getUsersList(state) {
      return state.userData;
    },
    getUsersEditData(state) {
      return state.userEditData;
    },
  },
};
